import React from "react";
import { Col } from "react-bootstrap";

interface IProps {
  isTemplateDivSelected: (templateId: number) => boolean;
  handleTemplateClick: (templateId: number) => void;
}

const TemplateSelectionFilter = (props: IProps) => {
  const { isTemplateDivSelected, handleTemplateClick } = props;
  return (
    <Col sm={12}>
       <h3 className="choosetemplate_heading">Choose Template</h3>
      <div className="choose-template-container">
       
        <div
          className={`template ${
            isTemplateDivSelected(3) ? "highlighted" : ""
          }`}
          onClick={() => handleTemplateClick(3)}
        >
          <div className="template-container ">
            <div className="ticker">
            <div className="template-text">
              WARNING: Tornado inbound 3:00PM-6:00PM. Stay indoors
            </div>
            </div>
            
          </div>
          <div className="template-heading">Ticker</div>
        </div>

        {/* <div
          className={`template ${
            isTemplateDivSelected(2) ? "highlighted" : ""
          }`}
          onClick={() => handleTemplateClick(2)}
        >
          <div className="template-container">
            <div className="Overlay">
            <div className="template-text">
              WARNING: Tornado inbound 3:00PM-6:00PM. Stay indoors
            </div>
            </div>
            
          </div>
          <div className="template-heading">Overlay</div>
        </div> */}

        <div
          className={`template ${
            isTemplateDivSelected(1) ? "highlighted" : ""
          }`}
          onClick={() => handleTemplateClick(1)}
        >
          <div className="template-container">
            <div className="fullscreen">
            <div className="template-text">
              WARNING: Tornado inbound 3:00PM-6:00PM. Stay indoors
            </div>
            </div>
            
          </div>
          <div className="template-heading">Fullscreen</div>
        </div>
      </div>
    </Col>
  );
};

export default TemplateSelectionFilter;
